import React, { useCallback, useContext, useMemo, useState } from 'react'
import styles from './vouchers-details.module.scss'
import { IState, IVouchers } from 'src/Interface'
import Button from 'src/components//button/Button'
import { StateContext } from '../../AppContext'
import { format } from 'date-fns'
import Map from 'src/components/map/Map'
import { baseApiURL } from 'src/utils/utils'
import axios from 'axios'
import { toast } from 'react-toastify'
import { DispatchContext } from 'src/AppContext'
import { gaEvenActions, gaEvent, gaEventCategories } from 'src/utils/ga/ga'
import { gaTaxibonMapper, gaUserMapper } from 'src/utils/ga/gaMapper'

interface IProps {
  close?: any
  voucherId: number
  fetchVouchers: () => void
  branchId: number
}


const OrdersDetails: React.FunctionComponent<IProps> = ({ close, branchId, voucherId, fetchVouchers = () => null }: IProps) => {
  const state: IState = useContext(StateContext)
  const [loading, setLoading] = useState(false)
  const dispatch = useContext(DispatchContext)
  const [currentVoucherId, setCurrentVoucherId] = useState(voucherId)
  const voucher: IVouchers = state.vouchers.find((v) => v.id === Number(currentVoucherId))
  const currentIndex: number = state.vouchers.findIndex((v) => v.id === Number(currentVoucherId))

  const deleteVoucher = useCallback(() => {
    setLoading(true)
    axios.delete(`${baseApiURL()}/branches/${branchId}/vouchers/${currentVoucherId}`,
      {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      }).then((result) => {
        gaEvent(gaEventCategories.taxibon, gaEvenActions.removed_taxibon, gaUserMapper(state), gaTaxibonMapper(voucher.id))
        close()
        dispatch({ type: 'SHOW_MODAL', showModal: false })
        fetchVouchers()
        setLoading(false)
      }).catch((err: any) => {
        toast(err.response.data.message)
      })
  }, [branchId, currentVoucherId, state.user.accessToken, close, dispatch, fetchVouchers])

  const statuses = useMemo(() => {
    return {
      ACTIVE: {
        label: 'Aktiv',
        style: 'statusGreen'
      },
      CANCELLED: {
        label: 'Udløbet',
        style: 'statusRed'
      },
      REDEEMED: {
        label: 'Indløst',
        style: 'green'
      },
      EXPIRED: {
        label: 'Udløbet',
        style: 'statusRed'
      },
      LOCKED: {
        label: 'I brug',
        style: 'statusBlue'
      }
    }
  }, [])


  if (!voucher) {
    return <span>loading</span>
  }

  return (
    <>
      <div className='tw-flex tw-flex-col tw-flex-full'>
        <header className={`${styles.header} ${statuses[voucher.status] ? styles[statuses[voucher.status].style] : ''}`}>
          <div className='tw-flex tw-flex-col'>
            <h4>{statuses[voucher.status] ? statuses[voucher.status].label : ''}
              <span className='opacity-60 tw-ml-2'></span>
            </h4>
            <p className='tw-text-base  tw-font-normal'>{voucher.voucherCustomerName}</p>
          </div>
          <span className={styles.closeIcon} onClick={() => close('/vouchers')}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </span>
        </header>
        <main className={styles.container}>
          <div className={styles.content}>
            {voucher.tripDetails ? <Map polyLine={voucher.tripDetails.polyLine} /> :
              <div className={styles.voucher}>
                {voucher.status === 'LOCKED' ?
                  <>
                    <svg xmlns="http://www.w3.org/2000/svg" className="tw-h-6 tw-w-6 tw-mb-3" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                    </svg>
                    <p className={styles.voucherLockedLabel}>Taxibonnen er i øjeblikket i brug</p>
                  </>
                  :
                  <>
                    <p className={`${styles.voucherDescription} ${voucher.status === 'CANCELLED' || voucher.status === 'EXPIRED' ? 'tw-opacity-50' : ''}`}>Reference</p>
                    <h2 className={`${styles.voucherCode} ${voucher.status === 'CANCELLED' || voucher.status === 'EXPIRED' ? 'tw-line-through  tw-opacity-50' : ''}`}>{voucher.reference}</h2>
                  </>}
              </div>}
            <div className='tw-mt-3'>
              {voucher.tripDetails && <>
                <p className={styles.deliveryInfo}>{`${format(new Date(voucher.tripDetails.tripFinishedAt), 'dd/MM/yy')} | ${format(new Date(voucher.tripDetails.requestedPickup), 'HH:mm')} - ${format(new Date(voucher.tripDetails.tripFinishedAt), 'HH:mm')}`}</p>
                <div className={styles.deliveryAddress}>
                  <h5 className='tw-flex tw-mb-2 tw-items-center'>
                    <svg className='tw-w-5 tw-h-5 fill-grey tw-mr-3' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                    </svg>
                    {voucher.tripDetails.pickupAddress.poi ? voucher.tripDetails.pickupAddress.poi : voucher.tripDetails.pickupAddress.fullAddress}
                  </h5>
                  {voucher.tripDetails.destinationAddress && <h5 className='tw-flex tw-items-center'>
                    <svg className='tw-w-5 tw-h-5 fill-grey tw-mr-3' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M3 6a3 3 0 013-3h10a1 1 0 01.8 1.6L14.25 8l2.55 3.4A1 1 0 0116 13H6a1 1 0 00-1 1v3a1 1 0 11-2 0V6z" clipRule="evenodd" />
                    </svg>
                    {voucher.tripDetails.destinationAddress.poi ? voucher.tripDetails.destinationAddress.poi : voucher.tripDetails.destinationAddress.fullAddress}
                  </h5>}
                </div>
              </>}
            </div>
            <div className={styles.voucherInfo}>
              {voucher.tripDetails ? <p>
                Pris
                <span className={styles.labelLarge}>{`${voucher.tripDetails.finalPrice} kr.`}</span>
              </p> : <p>
                Gyldig indtil
                <span className={styles.labelLarge}>
                  {format(new Date(voucher.expiryDate), 'dd. MMM yyyy, HH:mm')}
                </span>
              </p>}
              <p>
                Navn
                <span className={styles.labelLarge}>
                  {voucher.voucherCustomerName}
                </span>
              </p>
              <p>
                Telefon
                <span className={styles.labelLarge}>
                  {voucher.mobileUser.phone}
                </span>
              </p>
              {(voucher.tripDetails || voucher.status === 'LOCKED') && <p>
                Reference
                <span className={styles.labelLarge}>
                  {voucher.reference ? voucher.reference : '-'}
                </span>
              </p>}
            </div>
          </div>
          <aside className={styles.orderDetails}>
            <p>
              <span className={styles.label}>ID</span>
              {voucher.tripDetails ? voucher.tripDetails.globalApiId : voucher.id}
            </p>
            <p>
              <span className={styles.label}>Dato</span>
              {format(new Date(voucher.issuedDate), 'dd/MM/yy')}
            </p>
            {voucher.tripDetails && voucher.reference && <p>
              <span className={styles.label}>Kode</span>
              {voucher.reference}
            </p>}
            <p>
              <span className={styles.label}>Konto</span>
              {voucher.account}
            </p>
            <p>
              <span className={styles.label}>Udstedet af</span>
              {voucher.issuedBy}
            </p>
          </aside>
        </main>
        <footer className={styles.footer}>
          <div className='tw-flex tw-items-center'>
            <button className={`${styles.navigationButton} ${styles.navigationLeft}`} disabled={!state.vouchers[currentIndex - 1]} onClick={() => {
              setCurrentVoucherId(state.vouchers[currentIndex - 1].id)
            }}>
              <svg className='tw-h-6 tw-w-6' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            </button>

            <button
              className={`${styles.navigationButton} ${styles.navigationRight}`}
              disabled={!state.vouchers[currentIndex + 1]}
              onClick={() => {
                setCurrentVoucherId(state.vouchers[currentIndex + 1].id)
              }}>
              <svg className='tw-h-6 tw-w-6' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
              </svg>
            </button>
          </div>
          {voucher.status === 'ACTIVE' &&
            <>
              <Button disabled={loading} loading={loading} modifiers='tw-ml-auto' handleClick={() => dispatch({ type: 'SHOW_MODAL', showBackDrop: true, fetchVouchers, showModal: true, modalType: 'addVoucher', voucher, branchId, branch: state.branches.find(branch => Number(branch.id) === Number(branchId)) })} type='secondary' label='Rediger' />
              <Button handleClick={() => dispatch({ type: "SHOW_MODAL", showBackDrop: true, showModal: true, modalType: 'deleteConfirmation', title: 'Er du sikker på at deaktivere Taxibon?', text: 'Alle nuværende taxibonner vil blive annulleret', buttonText: 'Deaktiver taxibon', handleDelete: deleteVoucher })} disabled={loading} loading={loading} modifiers='tw-ml-2' type='destructive' label='Fjern taxibon' />
            </>}
        </footer>
      </div>
    </>
  )
}

export default OrdersDetails
